import http from '../http'

export default {
    /**
     * Consulta los tags del usuario.
     * @param {int} usuario
     * @returns {Promise}
     */
    all(usuario) {
        return http.get(`usuarios/${usuario}/tags`);
    },

    /**
     * Agrega un tag al usuario
     * @param {int} usuario
     * @param {int} tag
     * @returns {Promise}
     */
    add(usuario, tag) {
        return http.post(`usuarios/${usuario}/tags/${tag}`);
    },

    /**
     * Sincroniza una lista de tags al usuario
     * @param {int} usuario
     * @param {Array} tags
     * @returns {Promise}
     */
     sync(usuario, tags) {
        return http.put(`usuarios/${usuario}/tags`, { tags });
    },

    /**
     * Elimina un tag al usuario
     * @param {int} usuario 
     * @param {int} tag 
     * @returns {Promise}
     */
    delete(usuario, tag) {
        return http.delete(`usuarios/${usuario}/tags/${tag}`)
    }
}